import { render, staticRenderFns } from "./DialogBase.vue?vue&type=template&id=71ce8fb3&scoped=true&"
import script from "./DialogBase.vue?vue&type=script&lang=ts&"
export * from "./DialogBase.vue?vue&type=script&lang=ts&"
import style0 from "./DialogBase.vue?vue&type=style&index=0&id=71ce8fb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ce8fb3",
  null
  
)

export default component.exports